import { APP } from './tokens';

interface AppLayoutProps {
  sidebar?: React.ReactNode;
  topBar?: React.ReactNode;
  children: React.ReactNode;
  inputBar?: React.ReactNode;
  /** When true, children render in a flex-row (document + chat split). Default: column layout. */
  splitView?: boolean;
  /** When true, inputBar renders inside the scrollable area (flows with content) instead of pinned to the bottom. */
  inputBarInline?: boolean;
  /** Mobile shell keeps content full-width and routes side panels through drawers/sheets. */
  isMobile?: boolean;
}

export default function AppLayout({ sidebar, topBar, children, inputBar, splitView, inputBarInline, isMobile = false }: AppLayoutProps) {
  if (isMobile) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100vw',
          height: '100dvh',
          overflow: 'hidden',
          backgroundColor: APP.bgMain,
          fontFamily: APP.fontFamily,
        }}
      >
        {topBar}
        <div
          style={{
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: '0%',
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: splitView ? 'hidden' : 'auto',
            backgroundColor: APP.bgContent,
          }}
        >
          {children}
          {inputBarInline && inputBar}
        </div>
        {!inputBarInline && inputBar}
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: APP.bgMain,
        fontFamily: APP.fontFamily,
      }}
    >
      {/* Left sidebar */}
      {sidebar}

      {/* Main content area */}
      {splitView ? (
        /* Document view: children fill the entire right area as a flex row */
        <div
          style={{
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: '0%',
            width: 0,
            minWidth: 0,
            height: '100%',
            display: 'flex',
            overflow: 'hidden',
          }}
        >
          {children}
        </div>
      ) : (
        <div
          style={{
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: '0%',
            width: 0,
            minWidth: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: APP.bgContent,
            overflow: 'hidden',
          }}
        >
          {topBar}
          <div style={{ flexGrow: 1, flexShrink: 1, flexBasis: '0%', minWidth: 0, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
            {children}
            {inputBarInline && inputBar}
          </div>
          {!inputBarInline && inputBar}
        </div>
      )}
    </div>
  );
}
